var _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "pen"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.8 408.1H291.9v-92.8c0-15.2 12.4-27.6 27.6-27.6h200.7c15.2 0 27.6 12.4 27.6 27.6v92.8z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.3 413.6H286.4v-98.3c0-18.3 14.9-33.1 33.1-33.1h200.7c18.3 0 33.1 14.9 33.1 33.1v98.3z m-255.9-11h244.9v-87.3c0-12.2-9.9-22.1-22.1-22.1H319.5c-12.2 0-22.1 9.9-22.1 22.1v87.3z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.7 446.2H281c-6.6 0-12-5.4-12-12v-14.1c0-6.6 5.4-12 12-12h277.7c6.6 0 12 5.4 12 12v14.1c0 6.6-5.4 12-12 12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.7 451.7H281c-9.6 0-17.5-7.9-17.5-17.5v-14.1c0-9.6 7.9-17.5 17.5-17.5h277.7c9.6 0 17.5 7.9 17.5 17.5v14.1c0 9.7-7.8 17.5-17.5 17.5zM281 413.6c-3.6 0-6.5 2.9-6.5 6.5v14.1c0 3.6 2.9 6.5 6.5 6.5h277.7c3.6 0 6.5-2.9 6.5-6.5v-14.1c0-3.6-2.9-6.5-6.5-6.5H281z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.2 488.4c-20.7-4.2-41.2-8.2-78.7-11v-31.2H310.2v31.7c-36.8 3-57.6 7.4-78.9 11.8-30.4 6.2-52.1 32.9-52.1 63.9v232.8c0 11.9 9.7 21.6 21.6 21.6h438.1c11.9 0 21.6-9.7 21.6-21.6V552.3c0-31.1-21.9-57.8-52.3-63.9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.9 813.5H200.8c-14.9 0-27.1-12.1-27.1-27.1V553.5c0-33.4 23.8-62.6 56.5-69.3l1.8-0.4c19.5-4 39.6-8.1 72.7-11.1v-32.1H535v31.6c35 2.8 55 6.8 74.3 10.7 32.9 6.6 56.7 35.7 56.7 69.3v234.1c0 15-12.2 27.2-27.1 27.2zM315.7 451.7V483l-5.1 0.4c-35.4 2.9-56.3 7.2-76.4 11.3l-1.8 0.4c-27.7 5.7-47.7 30.3-47.7 58.5v232.8c0 8.9 7.2 16.1 16.1 16.1h438.1c8.9 0 16.1-7.2 16.1-16.1V552.3c0-28.3-20.1-53-47.9-58.5-19.9-4-40.5-8.1-78-10.9l-5.1-0.4v-30.8H315.7z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.4 830.7h-483c-6.5 0-11.7-5.2-11.7-11.7v-36.7c0-6.5 5.2-11.7 11.7-11.7h483c6.5 0 11.7 5.2 11.7 11.7V819c0 6.5-5.3 11.7-11.7 11.7z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.4 836.2h-483c-9.5 0-17.2-7.7-17.2-17.2v-36.7c0-9.5 7.7-17.2 17.2-17.2h483c9.5 0 17.2 7.7 17.2 17.2V819c0 9.5-7.7 17.2-17.2 17.2z m-483.1-60.1c-3.4 0-6.2 2.8-6.2 6.2V819c0 3.4 2.8 6.2 6.2 6.2h483c3.4 0 6.2-2.8 6.2-6.2v-36.7c0-3.4-2.8-6.2-6.2-6.2h-483z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2 588.3h481.3v110.9H179.2z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 704.7H173.7V582.8H666v121.9z m-481.3-11H655v-99.9H184.7v99.9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.5 703.2l6.5 127c0 2.1-1.3 3.8-2.6 5.4-16.2 20.7-37.5 55.4-45.9 67-3.2 4.5-9.5 5-12.3 0.2-8.5-14.7-30.7-53-45.8-67.3-1.4-1.3-2.2-3.2-2.2-5.1l6.5-127.3c0-3.9 3.1-7 7-7h81.7c4 0.1 7.1 3.3 7.1 7.1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.9 911.8h-0.7c-4.1-0.2-7.7-2.4-9.8-6.1-7.5-12.9-30.1-52.1-44.8-66-2.5-2.4-3.9-5.7-3.9-9.1v-0.3l6.4-127.2c0.1-6.8 5.7-12.4 12.5-12.4h81.7c6.9 0 12.4 5.5 12.5 12.4l6.5 127.2c0 4-2.2 6.9-3.7 8.8-10.3 13.2-22.7 32-32.6 47.2-5.4 8.3-10.1 15.4-13.2 19.6-2.5 3.7-6.6 5.9-10.9 5.9z m-48.1-81.1c0 0.4 0.2 0.7 0.5 1 14.2 13.4 33.5 45.5 46.7 68.5 0.3 0.6 0.6 0.6 0.9 0.6 0.6 0 1.5-0.4 2.2-1.3 2.9-4 7.5-11.1 12.9-19.2 10-15.3 22.6-34.4 33.1-48 0.4-0.6 1.3-1.6 1.4-2l-6.4-127c0-0.8-0.7-1.5-1.5-1.5h-81.7c-0.8 0-1.5 0.7-1.5 1.5v0.3l-6.6 127.1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.4 739.7h-47.6c-23.2 0-42-18.8-42-42V335.6h131.6v362.1c0 23.2-18.8 42-42 42z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.4 745.2h-47.6c-26.2 0-47.5-21.3-47.5-47.5V330.1h142.6v367.6c0 26.2-21.3 47.5-47.5 47.5z m-84.1-404.1v356.6c0 20.1 16.4 36.5 36.5 36.5h47.6c20.1 0 36.5-16.4 36.5-36.5V341.1H718.3z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.4 264.3c0-110.9-35.3-146.6-78.8-146.6s-78.8 35.7-78.8 146.6v157.8c0 33.5 27.2 60.7 60.7 60.7h36.2c33.5 0 60.7-27.2 60.7-60.7V264.3z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.7 488.3h-36.2c-36.5 0-66.2-29.7-66.2-66.2V264.3c0-52.8 8-92.4 23.9-117.8 14.2-22.7 34.5-34.3 60.4-34.3s46.1 11.5 60.4 34.3c15.9 25.4 23.9 65 23.9 117.8v157.8c0 36.5-29.7 66.2-66.2 66.2z m-18.1-365.1c-21.8 0-38.9 9.8-51 29.1-14.8 23.6-22.2 61.2-22.2 112v157.8c0 30.4 24.8 55.2 55.2 55.2h36.2c30.4 0 55.2-24.8 55.2-55.2V264.3c0-50.7-7.5-88.4-22.2-112-12.2-19.3-29.4-29.1-51.2-29.1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.6 791.1m-14.3 0a14.3 14.3 0 1 0 28.6 0 14.3 14.3 0 1 0-28.6 0Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.6 810.9c-10.9 0-19.8-8.9-19.8-19.8s8.9-19.8 19.8-19.8 19.8 8.9 19.8 19.8-8.9 19.8-19.8 19.8z m0-28.6c-4.9 0-8.8 3.9-8.8 8.8s3.9 8.8 8.8 8.8 8.8-3.9 8.8-8.8-3.9-8.8-8.8-8.8z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.1 805.4h11v97.5h-11z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.6 421.7c-3.3 0-6-2.7-6-6V194.9c0-3.3 2.7-6 6-6s6 2.7 6 6v220.8c0 3.3-2.7 6-6 6z",
    fill: "#ffffff"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 28.1667C18.07 28.8817 16.8783 29.9434 15.99 31.265C15.4917 32.0234 15.4917 32.9767 15.99 33.735C16.8783 35.0567 18.07 36.1184 19.5 36.8334",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.955 28.1667C34.385 28.8817 35.5767 29.9434 36.465 31.265C36.9633 32.0234 36.9633 32.9767 36.465 33.735C35.5767 35.0567 34.385 36.1184 32.955 36.8334",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.33333 28.1666V32.5C4.33333 43.3333 8.66666 47.6666 19.5 47.6666H32.5C43.3333 47.6666 47.6667 43.3333 47.6667 32.5V19.5C47.6667 8.66665 43.3333 4.33331 32.5 4.33331H19.5C8.66666 4.33331 4.33333 8.66665 4.33333 19.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.83167 17.355L46.475 17.3333",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "android"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4167 49.5V56.25C27.4167 57.1186 26.7019 57.8333 25.8333 57.8333C24.9648 57.8333 24.25 57.1186 24.25 56.25V49.5H27.4167Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.75 49.5V56.25C37.75 57.1186 37.0352 57.8333 36.1667 57.8333C35.2981 57.8333 34.5833 57.1186 34.5833 56.25V49.5H37.75Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9167 28.4167V41.3333C42.9167 43.6227 41.0394 45.5 38.75 45.5H23.25C20.9606 45.5 19.0833 43.6227 19.0833 41.3333V28.4167C19.0833 26.1273 20.9606 24.25 23.25 24.25H38.75C41.0394 24.25 42.9167 26.1273 42.9167 28.4167Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 28.4166V38.75C11.9167 39.6185 11.2019 40.3333 10.3333 40.3333C9.46478 40.3333 8.75 39.6185 8.75 38.75V28.4166C8.75 27.5481 9.46478 26.8333 10.3333 26.8333C11.2019 26.8333 11.9167 27.5481 11.9167 28.4166Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.25 28.4166V38.75C53.25 39.6185 52.5352 40.3333 51.6667 40.3333C50.7981 40.3333 50.0833 39.6185 50.0833 38.75V28.4166C50.0833 27.5481 50.7981 26.8333 51.6667 26.8333C52.5352 26.8333 53.25 27.5481 53.25 28.4166Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 15.5C40.3333 17.2211 38.9211 18.6334 37.2001 18.6334H24.7999C23.0789 18.6334 21.6667 17.2211 21.6667 15.5C21.6667 10.3431 25.8431 6.16669 31 6.16669C36.1569 6.16669 40.3333 10.3431 40.3333 15.5Z",
    stroke: "white",
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2916 16.2966H16.2916V15.2966V5.1801C16.2916 3.42393 17.577 1.91401 19.3503 1.63208C24.7457 0.79598 30.2492 0.795979 35.6446 1.63208C37.4179 1.91399 38.7033 3.42392 38.7033 5.1801V9.79851C38.7033 10.016 38.5462 10.173 38.3288 10.173H36.9543C35.6322 10.173 34.5797 11.2255 34.5797 12.5476V21.3996C34.5797 21.9469 34.1477 22.3789 33.6004 22.3789H21.3946C15.2067 22.3789 10.168 27.4175 10.168 33.6054V38.3338C10.168 38.5513 10.011 38.7083 9.7935 38.7083H5.1751C3.41891 38.7083 1.90898 37.4229 1.62707 35.6496C0.790974 30.2542 0.790975 24.7507 1.62708 19.3553C1.909 17.582 3.41892 16.2966 5.1751 16.2966H15.2916ZM19.7073 7.65424C19.7073 8.53161 20.1181 9.32458 20.6771 9.88363C21.2362 10.4427 22.0291 10.8535 22.9065 10.8535C23.7915 10.8535 24.591 10.4478 25.157 9.8866C25.7219 9.32641 26.1333 8.5322 26.1333 7.65424C26.1333 6.80854 25.7508 5.91702 25.1409 5.34057C24.5652 4.77197 23.7109 4.42751 22.9065 4.42751C22.0286 4.42751 21.2344 4.83884 20.6742 5.40376C20.1129 5.96971 19.7073 6.76923 19.7073 7.65424Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7034 38.7084H38.7034V39.7084V49.8249C38.7034 51.5811 37.4179 53.0911 35.6446 53.3729C30.2492 54.209 24.7458 54.209 19.3504 53.373C17.5771 53.0911 16.2917 51.5811 16.2917 49.8249V33.6055C16.2917 30.7764 18.5655 28.5025 21.3946 28.5025H33.6004C37.537 28.5025 40.7034 25.3028 40.7034 21.3996V16.6712C40.7034 16.4538 40.8604 16.2967 41.0779 16.2967H49.8199C51.5761 16.2967 53.086 17.5821 53.3679 19.3555C54.204 24.7508 54.204 30.2543 53.3679 35.6496C53.086 37.423 51.5761 38.7084 49.8199 38.7084H39.7034ZM34.3103 44.9978L34.3084 44.9961C33.7383 44.4667 32.8629 44.124 32.0885 44.124C31.2029 44.124 30.4021 44.5302 29.835 45.0973C29.2679 45.6644 28.8617 46.4652 28.8617 47.3508C28.8617 48.2441 29.2812 49.0449 29.8483 49.6072C30.4141 50.1684 31.213 50.5775 32.0885 50.5775C32.9674 50.5775 33.7614 50.1653 34.3242 49.5978C34.8888 49.0286 35.2944 48.2302 35.3149 47.3465L35.3152 47.3349V47.3233C35.3152 46.5058 34.9321 45.5782 34.3103 44.9978Z",
    stroke: "white",
    strokeWidth: 2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "python"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2916 16.2966H16.2916V15.2966V5.1801C16.2916 3.42393 17.577 1.91401 19.3503 1.63208C24.7457 0.79598 30.2492 0.795979 35.6446 1.63208C37.4179 1.91399 38.7033 3.42392 38.7033 5.1801V9.79851C38.7033 10.016 38.5462 10.173 38.3288 10.173H36.9543C35.6322 10.173 34.5797 11.2255 34.5797 12.5476V21.3996C34.5797 21.9469 34.1477 22.3789 33.6004 22.3789H21.3946C15.2067 22.3789 10.168 27.4175 10.168 33.6054V38.3338C10.168 38.5513 10.011 38.7083 9.7935 38.7083H5.1751C3.41891 38.7083 1.90898 37.4229 1.62707 35.6496C0.790974 30.2542 0.790975 24.7507 1.62708 19.3553C1.909 17.582 3.41892 16.2966 5.1751 16.2966H15.2916ZM19.7073 7.65424C19.7073 8.53161 20.1181 9.32458 20.6771 9.88363C21.2362 10.4427 22.0291 10.8535 22.9065 10.8535C23.7915 10.8535 24.591 10.4478 25.157 9.8866C25.7219 9.32641 26.1333 8.5322 26.1333 7.65424C26.1333 6.80854 25.7508 5.91702 25.1409 5.34057C24.5652 4.77197 23.7109 4.42751 22.9065 4.42751C22.0286 4.42751 21.2344 4.83884 20.6742 5.40376C20.1129 5.96971 19.7073 6.76923 19.7073 7.65424Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7034 38.7084H38.7034V39.7084V49.8249C38.7034 51.5811 37.4179 53.0911 35.6446 53.3729C30.2492 54.209 24.7458 54.209 19.3504 53.373C17.5771 53.0911 16.2917 51.5811 16.2917 49.8249V33.6055C16.2917 30.7764 18.5655 28.5025 21.3946 28.5025H33.6004C37.537 28.5025 40.7034 25.3028 40.7034 21.3996V16.6712C40.7034 16.4538 40.8604 16.2967 41.0779 16.2967H49.8199C51.5761 16.2967 53.086 17.5821 53.3679 19.3555C54.204 24.7508 54.204 30.2543 53.3679 35.6496C53.086 37.423 51.5761 38.7084 49.8199 38.7084H39.7034ZM34.3103 44.9978L34.3084 44.9961C33.7383 44.4667 32.8629 44.124 32.0885 44.124C31.2029 44.124 30.4021 44.5302 29.835 45.0973C29.2679 45.6644 28.8617 46.4652 28.8617 47.3508C28.8617 48.2441 29.2812 49.0449 29.8483 49.6072C30.4141 50.1684 31.213 50.5775 32.0885 50.5775C32.9674 50.5775 33.7614 50.1653 34.3242 49.5978C34.8888 49.0286 35.2944 48.2302 35.3149 47.3465L35.3152 47.3349V47.3233C35.3152 46.5058 34.9321 45.5782 34.3103 44.9978Z",
    stroke: "white",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "javaScript"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.895 12.7725V32.9775L11.875 30.9525",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.125 12.75L25.0374 13.7625V24.9L32.125 23.8875V30.975L24.0251 33",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47008 8.04751L2.02005 3.9975C1.86255 2.67 2.92003 1.5 4.24753 1.5H39.7301C41.0801 1.5 42.115 2.67 41.9575 3.9975L37.9076 40.4925C37.8176 41.3925 37.165 42.1575 36.2875 42.405L22.6076 46.32C22.2026 46.4325 21.775 46.4325 21.37 46.32L7.6901 42.405C6.8126 42.1575 6.18252 41.3925 6.07002 40.4925L3.59508 18.1725",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "git-repo"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 35.65V24.8",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5375 46.5C23.3197 46.5 25.5751 44.2446 25.5751 41.4625C25.5751 38.6803 23.3197 36.425 20.5375 36.425C17.7554 36.425 15.5 38.6803 15.5 41.4625C15.5 44.2446 17.7554 46.5 20.5375 46.5Z",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 24.8C22.7181 24.8 24.7999 22.7181 24.7999 20.15C24.7999 17.5818 22.7181 15.5 20.15 15.5C17.5818 15.5 15.5 17.5818 15.5 20.15C15.5 22.7181 17.5818 24.8 20.15 24.8Z",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.85 24.8C44.4182 24.8 46.5 22.7181 46.5 20.15C46.5 17.5818 44.4182 15.5 41.85 15.5C39.2819 15.5 37.2001 17.5818 37.2001 20.15C37.2001 22.7181 39.2819 24.8 41.85 24.8Z",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3567 35.6499C21.0542 32.9374 23.5342 30.9225 26.4533 30.9483L31.775 30.9741C35.8308 30.9999 39.2925 28.3907 40.5584 24.7482",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 5.16661H38.75C51.6667 5.16661 56.8333 10.3333 56.8333 23.2499V38.7499C56.8333 51.6666 51.6667 56.8333 38.75 56.8333H23.25C10.3333 56.8333 5.16666 51.6666 5.16666 38.7499V23.2499C5.16666 10.3333 10.3333 5.16661 23.25 5.16661Z",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "slider"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32.02C37.1 32.02 38 32.92 38 34.02V36C38 40.4 35 44 30 44H18C13 44 10 40.4 10 36V34.02C10 32.92 10.9 32.02 12 32.02H36Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38 12V27C38 28.1 37.1 29 36 29H12C10.9 29 10 28.1 10 27V12C10 7.60003 13 4.00003 18 4.00003H30C35 4.00003 38 7.60003 38 12Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6 41.5C5.18 41.5 4.5 40.82 4.5 40V7.99997C4.5 7.17997 5.18 6.49997 6 6.49997C6.82 6.49997 7.5 7.17997 7.5 7.99997V40C7.5 40.82 6.82 41.5 6 41.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41.5C41.18 41.5 40.5 40.82 40.5 40V7.99997C40.5 7.17997 41.18 6.49997 42 6.49997C42.82 6.49997 43.5 7.17997 43.5 7.99997V40C43.5 40.82 42.82 41.5 42 41.5Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSvg);
export default __webpack_public_path__ + "static/media/icon-svg.ec9db0e2dea4c27b5f04636c60d49516.svg";
export { ForwardRef as ReactComponent };